import React from 'react';
import { Route, Switch } from 'react-router-dom';

import AgencyCodeList from './containers/AgencyCodeList';
import AgencyCodeNew from './containers/AgencyCodeNew';

const AgencyCode = ({ match }) => (
  <Switch>
    <Route exact path={`${match.url}/`} component={AgencyCodeList} />
    <Route path={`${match.url}/new`} component={AgencyCodeNew} />
  </Switch>
);

export default AgencyCode;
